/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Service
 *
 * 1 = Sales
 *
 * 2 = Maintenance
 */
export enum ValetingGlobalType {
  Service = 0,
  Sales = 1,
  Maintenance = 2,
}
